import React from "react";

const CLIENTS = [
  { name: "Sadia" },
  { name: "Quatá Queijos" },
  { name: "Bradesco" },
  { name: "Itaú" },
  { name: "Senac" },
  { name: "Dell" },
  { name: "Pantone" },
  { name: "Wizard" },
  { name: "Nivea" },
  { name: "Pinterest" },
];

const Clients = () => {
  return (
    <section
      id="clientes"
      data-testid="clients-section"
      className="py-24 lg:py-32 bg-[var(--mn-black)] text-white overflow-hidden"
    >
      <div className="max-w-[1200px] mx-auto px-6">
        <div className="text-center mb-16">
          <span className="inline-block text-[0.72rem] font-semibold uppercase tracking-[0.28em] text-[var(--mn-gold)] mb-4">
            Clientes que confiam
          </span>
          <h2 className="font-serif-display font-bold text-3xl md:text-4xl lg:text-5xl leading-[1.1] mb-4">
            Marcas que já entregaram brindes
            <br />
            <span className="italic text-[var(--mn-gold)]">com a M NAIEF</span>
          </h2>
          <p className="text-white/60 text-sm md:text-base max-w-2xl mx-auto leading-relaxed">
            Ao longo dos anos, produzimos brindes personalizados para empresas de diferentes portes e segmentos — indústria, educação, financeiro, moda e tecnologia.
          </p>
        </div>

        <div
          data-testid="clients-grid"
          className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-x-8 gap-y-10"
        >
          {CLIENTS.map((client) => (
            <div
              key={client.name}
              data-testid={`client-${client.name.toLowerCase().replace(/\s+/g, "-").replace(/[áàâã]/g, "a").replace(/[éê]/g, "e").replace(/[íî]/g, "i").replace(/[óô]/g, "o").replace(/[úû]/g, "u").replace(/ç/g, "c")}`}
              className="group flex items-center justify-center min-h-[80px] px-6 py-4 border border-white/10 rounded-lg bg-white/[0.02] backdrop-blur-sm transition-all duration-300 hover:border-[var(--mn-gold)]/40 hover:bg-white/[0.05]"
            >
              <span className="font-serif-display font-bold text-lg md:text-xl text-white/85 tracking-tight transition-colors group-hover:text-[var(--mn-gold)] text-center">
                {client.name}
              </span>
            </div>
          ))}
        </div>

        <div className="mt-16 text-center">
          <p className="text-white/50 text-xs tracking-[0.2em] uppercase">
            + centenas de empresas atendidas nos últimos anos
          </p>
        </div>
      </div>
    </section>
  );
};

export default Clients;
